import React, {useReducer} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import UIPopupContext, {uiPopupContextReducer} from "./UIPopupContext";
import {setUiPopupState} from "../../../actions/actionFunctions";
import {UI_POPUP_TYPES} from "../../../reducers/messageBoxReducer";
import UiPopupIMEFieldsContent from "./IMEFields/UiPopupIMEFieldsContent";
import WithOverlay from "../withOverlayHoc";

const getContent = (uiPopupState) => {
  switch (uiPopupState.type) {
    case UI_POPUP_TYPES.imeValues:
      return <UiPopupIMEFieldsContent/>
    default:
      return null
  }
}


const UIPopup = (props) => {

  const {uiPopupState, setUiPopupState, intl} = props;

  const [uiPopupContext, uiPopupDispatch] = useReducer(uiPopupContextReducer, {...uiPopupState.context});

  return (
    <WithOverlay className="look-overlay--style" popupClassName="look-popup">
      {(hideOverlay) => {
        const closePopup = (isCancel = false) => {
          if (uiPopupState.onCloseClick) {
            uiPopupState.onCloseClick(isCancel);
          }
          hideOverlay(() => {
            setUiPopupState({opened: false})
          });
        };
        return (
          <UIPopupContext.Provider value={{uiPopupContext, uiPopupDispatch}} >
            <div className={"ui-popup ui-popup--common flex flex--column " + uiPopupState.className} style={uiPopupState.style}>
              {uiPopupState.headerTextId ? (
                <div className="flex flex--between bordered pl-15 pr-075 pt-05 pb-05 w-full text-left">
                  <span className="ui-popup__header-title">
                    <FormattedMessage id={uiPopupState.headerTextId}/>
                  </span>
                  <button className="ui-close" onClick={() => closePopup(true)}/>
                </div>
              ) : null}
              <div className="ui-popup__content pr-075 pl-075 w-full pt-15">
                {getContent(uiPopupState)}
              </div>
              <div className="w-full text-right p-15">
                {uiPopupState.buttons.map((button) => {
                  const disabled = button.isSaveButton && uiPopupContext.saveButtonDisabled;
                  return (
                    <button key={button.textId || "buttons.cancel"}
                            className={(button.className || "ui-button2 text-uppercase ui-button2--blue")
                              + (disabled ? " ui-button2--disabled" : "")}
                            disabled={disabled}
                            onClick={() => disabled ? null : button.onClick
                              ? button.onClick(closePopup, uiPopupContext, intl)
                              : closePopup(true)}>
                      <FormattedMessage id={button.textId || "buttons.cancel"}/>
                    </button>
                  )
                })}
              </div>
            </div>
          </UIPopupContext.Provider>
        )
      }}
    </WithOverlay>
  )
};

UIPopup.propTypes = {
  uiPopupState: PropTypes.shape({
    opened: PropTypes.bool.isRequired,
    headerTextId: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
    context: PropTypes.object,
    type: PropTypes.oneOf(Object.values(UI_POPUP_TYPES)),
    buttons: PropTypes.arrayOf(PropTypes.shape({
      textId: PropTypes.string,
      disabled: PropTypes.bool,
      onClick: PropTypes.func,
    }))
  })
}

const mapStateToProps = (store) => {
  const {uiPopupState} = store.messageBoxState;
  return {
    uiPopupState
  }
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UIPopup)
)
